module.exports = __webpack_public_path__ + "static/buronabivnoj-fundament-3e2deefcbb1f071d55b0ef7cb9c561fe.jpg";